import React from 'react';
import { Divider, Radio } from 'antd';
import { LeadTimeOptionCard } from '../Cards/LeadTimeOptionCard';
import dayjs from 'dayjs';
export const LeadTimePriceOptions = props => {
    const { lineItem, handleChange, loading = false, onChange, direction = 'grid' } = props;
    const options = lineItem?.pricing_options?.prices_by_quantity?.[lineItem?.quantity];
    const selectedValue = options?.find(option => option.lead_time === lineItem?.lead_time)?.id || options?.[0]?.id;
    const hasStandardOptions = options?.some(option => option.type === 'Standard');
    const hasExpeditedOptions = options?.some(option => option.type === 'Expedited');
    const hasMultiplePrices = lineItem?.pricing_options?.prices_by_quantity?.[lineItem?.quantity] &&
        lineItem?.pricing_options?.prices_by_quantity?.[lineItem?.quantity]?.length > 1;
    const baseClasses = 'grid gap-2 flex-wrap gap-4';
    const directionClasses = direction === 'grid'
        ? hasMultiplePrices
            ? 'grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3'
            : 'grid grid-cols-1'
        : 'flex flex-col';
    return (React.createElement("div", null,
        React.createElement(Radio.Group, { value: selectedValue || 0, onChange: e => {
                onChange?.(e.target.value);
                handleChange?.(e.target.value);
            } },
            React.createElement("div", { className: `${baseClasses} ${directionClasses}` }, lineItem?.pricing_options?.prices_by_quantity?.[lineItem?.quantity]
                ?.filter(option => option?.type === 'Expedited')
                ?.map(option => (React.createElement(LeadTimeOptionCard, { key: option?.id, option: option, lineItem: lineItem, readonly: handleChange === undefined, isDisabled: handleChange === undefined && dayjs(option?.expiration_date).isBefore(dayjs()), loading: loading, isSelected: option?.id === selectedValue })))),
            hasStandardOptions && hasExpeditedOptions && React.createElement(Divider, { className: "my-3" }),
            React.createElement("div", { className: `${baseClasses} ${directionClasses}` }, options
                ?.filter(option => option?.type === 'Standard')
                ?.map(option => (React.createElement(LeadTimeOptionCard, { key: option?.id, option: option, lineItem: lineItem, readonly: handleChange === undefined, isDisabled: handleChange === undefined && dayjs(option?.expiration_date).isBefore(dayjs()), loading: loading, isSelected: option?.id === selectedValue })))))));
};
